import { always, ifElse, path } from 'ramda';

import { formatPhoneNumber } from './formatPhoneNumber';
import { EAnswerField } from '../../../types/form';
import { TAnswersState } from '../../FormContainer/types/internal';

/**
 * Возвращает initialValue для телефона
 * Если есть непустой телефон - пропустит через форматтер
 * Если нет телефона - вернет пустую строку
 * */
export const getInitialPhoneValue = (answerField: EAnswerField, answersState: TAnswersState) =>
  ifElse(Boolean, formatPhoneNumber, always(''))(path([answerField, 'value'], answersState));
